module.exports = __webpack_public_path__ + "img/3.eeac9f40.png";